<div class="program" *ngIf="program">
    <div class="program-overlay" (click)="close.emit()"></div>
    <div class="program-panel horizontal-focusable-container" data-blocked>
        <div class="image">
            <div class="image-gradient"></div>
            <img [src]="program.image +'?w=595&h=335'" [alt]="program.name" />
        </div>
        <p class="subtitle">{{ program.startTimeEpoch | date : 'EEE, MMM dd | hh:mm a': undefined : dateLocale }} -
            {{program.endTimeEpoch | date: 'hh:mm a'}}</p>
        <div class="title-container">
            <p class="title">{{program.name}}</p>
        </div>
        <div class="info" *ngIf="program">
            <span class="rating">{{ getRatingDetails() }}</span>
            <p>
                {{ program.contentGenre | MetaListPipe : '•' }}
            </p>
        </div>
        <p [attr.aria-label]="program.description" class="description">{{program.description}}</p>
        <div class="actions">
            <button *ngIf="isPlayable; else blockedContent" aria-live="polite"
                class="primary-button icon-button focusable-element" tabindex="0" (click)="play.emit(program)">
                <app-icon name="play"></app-icon>
                {{'epg.playNow' | translate }}</button>
            <ng-template #blockedContent>
                <button *ngIf="isLoggedIn; else anonymous" aria-live="polite"
                    class="disabled-button icon-button focusable-element" tabindex="0" (click)="locked.emit(program)">
                    <app-icon name="square-lock"></app-icon>
                    {{'dialog.notAvailable' | translate }}</button>
            </ng-template>
            <ng-template #anonymous>
                <button aria-live="polite" class="primary-button icon-button focusable-element" tabindex="0"
                    (click)="signIn.emit(program)">
                    <app-icon name="sign-in"></app-icon>
                    {{'dialog.signIn' | translate }}</button>
            </ng-template>

        </div>
    </div>
</div>